/**
 * Tiny little IO wrapper for toggling a class on intersection.
 *
 * @param {Element} element
 * @param {(entry: IntersectionObserverEntry) => void} fn
 */

import { get } from 'svelte/store';

export function onIntersection(element, fn, options) {
  const observer = new IntersectionObserver(processIntersection, options);

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  function processIntersection(entries) {
    entries.forEach(fn);
  }

  observer.observe(element);
}

// MOBILE NAV ACTIVE WHEN SCROLLING INTO SECTION

const navElements = document.querySelectorAll('nav#nav-container');
const navElementOptions = {
  root: null,
  rootMargin: '0% 3% -95% 0%',
  treshold: 1,
};

navElements.forEach((el) => {
  onIntersection(
    el,
    (entry) => {
      var idName = '#' + entry.target.id;
      let el = document.querySelector(idName);
      if (!entry.isIntersecting) {
        el.classList.remove('stuck');
        return;
      } else {
        el.classList.add('stuck');
      }
    },
    navElementOptions
  );
  let navLinks = el.querySelectorAll('ul.buttons li a');
});

// dropdown onchange
let dropdownElement = document.querySelector('select#dropnav');
dropdownElement?.addEventListener('change', (e) => {
  let getSelectedValue = dropdownElement.value;
  let goToID = '#' + getSelectedValue.replace('-nav', '');
  window.location.href = goToID;
});

// section heds
let sectionHedItems = document.querySelectorAll('.section-container');
const sectionHedItemsOptions = {
  root: null,
  rootMargin: '0% -25% -25% 0%',
  treshold: 1,
};

let allNavButtons = document.querySelectorAll('li.nav-item a');

sectionHedItems.forEach((el) => {
  onIntersection(
    el,
    (entry) => {
      if (!entry.isIntersecting) {
      } else {
        let getID = el.getAttribute('id');
        updateStickyNav(getID);
        updateOptionNav(getID);
      }
    },
    sectionHedItemsOptions
  );
});

// update nav var as you go into sections
function updateStickyNav(sectionID) {
  ////// buttons ///////////////////
  // get the id of the nav bar button to turn active
  let getButtonName = sectionID + '-nav-button';
  // remove active from all buttons
  allNavButtons.forEach((bt) => {
    if (bt.getAttribute('id') == getButtonName) {
      bt.classList.add('active');
    } else {
      bt.classList.remove('active');
    }
  });
}

// update mobile dropdown
function updateOptionNav(sectionID) {
  let getOptionName = sectionID + '-nav';
  dropdownElement.value = getOptionName;
}
